import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// A `typography-*` class (Text's variants, typography.css) reads weight and line height from the
// `--tw-*` variables, so an earlier `font-*` or `leading-*` class would leak into it.
const mergeClasses = extendTailwindMerge<'typography'>({
  override: { conflictingClassGroups: { 'font-size': [] } },
  extend: {
    classGroups: { typography: [{ typography: [() => true] }] },
    conflictingClassGroups: { typography: ['font-size', 'leading', 'font-weight'] },
  },
});

export function cn(...inputs: ClassValue[]) {
  return mergeClasses(clsx(inputs));
}
